import {Button, Grid} from "@material-ui/core";
import SortingDropdown from "../sorting-dropdown/SortingDropdown";
import PropTypes from "prop-types";
import Box from "@material-ui/core/Box";
import ButtonWithDropDownMenu from "../../../components/ui/buttons/button-with-dropdown/ButtonWithDropDownMenu";

const SortingAndButtonsAboveTable = (props) => {
    const getAzioniText = (selectedData) => {
        if (!selectedData)
            return "Azioni"

        return `Azioni (${selectedData})`
    }

    return (
        <>
            <Box marginBottom="1em">
                <Grid container
                      justifyContent="space-between"
                      alignItems="center">
                    <Grid item
                          xs={12} md={6}>
                        <SortingDropdown sortingCriteria={props.sortingCriteria}
                                         sortingValue={props.sortingValue}
                                         changeSortingCriteria={props.changeSortingCriteria}/>
                    </Grid>

                    <Grid item container
                          justifyContent="flex-end"
                          alignItems="center"
                          xs={12} md={6}
                          spacing={1}>
                        <Grid item>
                            {props.additionalButton}
                        </Grid>

                        {props.selectedData ? <Grid item>
                            <Button color="primary"
                                    onClick={props.handleAnnullaClick}>
                                Annulla Selezione
                            </Button>
                        </Grid> : null}

                        {!props.hideButton && <Grid item>
                            <ButtonWithDropDownMenu
                                dropDownMenuItems={props.menuItems}
                                disabled={props.shouldDisable ? false : !props.selectedData}
                                text={getAzioniText(props.selectedData)}
                            />
                        </Grid>}
                    </Grid>
                </Grid>
            </Box>
        </>

    )
}

SortingAndButtonsAboveTable.propTypes = {
    sortingValue: PropTypes.string,
    changeSortingCriteria: PropTypes.func,
    sortingCriteria: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            text: PropTypes.string.isRequired
        })),
    menuItems: PropTypes.arrayOf(
        PropTypes.shape({
            text: PropTypes.string.isRequired,
            icon: PropTypes.element,
            disabled: PropTypes.bool,
            handleClick: PropTypes.func.isRequired,
            roles: PropTypes.string
        }).isRequired
    ).isRequired,
    selectedData: PropTypes.number,
    handleAnnullaClick: PropTypes.func.isRequired,
    hideButton: PropTypes.bool,
    additionalButton: PropTypes.node
}

SortingAndButtonsAboveTable.defaultProps = {
    hideButton: false,
}

export {SortingAndButtonsAboveTable};
